import { wrapTextNodes } from './_wrapTextNodes';

export function letterFadeAnimate() {
  const els = document.querySelectorAll('.letter-fade-animate');
  if (els.length) {
    els.forEach(container => {
      const fadeInInterval = parseInt(container.getAttribute('data-fade-in-interval')) || 50; // フェードインが始まる間隔
      const fadeInDuration = parseFloat(container.getAttribute('data-fade-in-duration')) || 1.5; // フェードインの速度（秒）
      const rootMargin = container.getAttribute('data-root-margin') || '0px 0px -10% 0px'; // フェードイン開始位置

      const animateEnabled = container.getAttribute('data-animate-enabled') || 'true';
      const maxMove = parseFloat(container.getAttribute('data-max-move')) || 0.2;
      const minMove = parseFloat(container.getAttribute('data-min-move')) || 0.075;
      const maxSpeed = parseInt(container.getAttribute('data-max-speed')) || 6000;
      const minSpeed = parseInt(container.getAttribute('data-min-speed')) || 3000;
      const maxScale = parseFloat(container.getAttribute('data-max-scale')) || 1.1;
      const minScale = parseFloat(container.getAttribute('data-min-scale')) || 0.9;

      wrapTextNodes(container);
      container.classList.add('is-init');

      const letters = Array.from(container.querySelectorAll('.letter'));
      const randomizedLetters = letters.sort(() => Math.random() - 0.5);

      // IntersectionObserverを設定
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 要素が指定の位置に達した時にフェードインとアニメーションを開始
            randomizedLetters.forEach((letter, index) => {
              const fadeInDelay = index * fadeInInterval; // フェードインの間隔を指定

              setTimeout(() => {
                letter.style.transition = `opacity ${fadeInDuration}s ease`; // フェード時間を指定
                letter.style.opacity = 1;

                if (animateEnabled === 'true') { // アニメーションが有効な場合のみ実行
                  const animateLetter = () => {
                    const xMove = (Math.random() * (maxMove - minMove) + minMove) * (Math.random() < 0.5 ? -1 : 1);
                    const yMove = (Math.random() * (maxMove - minMove) + minMove) * (Math.random() < 0.5 ? -1 : 1);
                    const moveDuration = Math.random() * (maxSpeed - minSpeed) + minSpeed;
                    const scaleValue = Math.random() * (maxScale - minScale) + minScale;

                    letter.animate([
                      { transform: `translate(0, 0) scale(1)` },
                      { transform: `translate(${xMove}rem, ${yMove}rem) scale(${scaleValue})` }
                    ], {
                      duration: Math.max(moveDuration, 0),
                      easing: 'linear',
                      iterations: Infinity,
                      direction: 'alternate',
                      fill: 'forwards'
                    });
                  };

                  animateLetter();
                }
              }, fadeInDelay);
            });
            // 一度表示された要素に対しては再度監視しないようにする
            observer.unobserve(container);
          }
        });
      }, {
        rootMargin: rootMargin // フェードイン開始位置を指定
      });

      // 監視対象に要素を追加
      observer.observe(container);
    });
  }
}